import * as tslib_1 from "tslib";
import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setSubCategoryState', function setSubCategoryState(subCategory, subCategoryState) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var store;
        return tslib_1.__generator(this, function (_a) {
            store = getStore();
            store.subCategoryLoadState.set(subCategory.key, subCategoryState);
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=setSubCategoryState.js.map